import React from "react";
import styles from "./seat_booking.module.scss";

export const EventSeatBooking = () => {
  return (
    <section
      className={styles.booking_section}
      style={{
        backgroundImage: `url("/assets/images/events/images/booking-background.webp")`,
      }}
    >
      <div className={styles.booking_content}>
        <div className={`container ${styles.booking_area}`}>
          <div className={styles.content_wrapper}>
            <h3 className={styles.heading}>
              Save your seat for the best Distance Learning Conference of the
              year.
            </h3>
            <div className={styles.description}>
              <div className={styles.description_text}>
                Grab your seat while they last we have a limited <br /> number
                available
              </div>
              <div className={styles.border_left}></div>
            </div>
          </div>

          <div className={styles.input_container}>
            <input type="text" placeholder="Your email" />
            <button>Submit</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventSeatBooking;
